import axios from 'axios';

const api = axios.create({
  baseURL: window.configs.baseURL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (!token) return config;
  config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      return window.location.replace('/login');
    }

    return Promise.reject(error);
  }
);

export default api;
